module.exports = __webpack_public_path__ + "img/KMD_WHITE.5e10af02.svg";